"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrevious = void 0;
var react_1 = require("react");
/**
 * Returns the value passed to the hook on previous render.
 *
 * Yields `undefined` on first render.
 *
 * @param value Value to yield on next render
 */
function usePrevious(value) {
    var prev = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        prev.current = value;
    });
    return prev.current;
}
exports.usePrevious = usePrevious;
